"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import "../styles/Login.css"

function Login() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  })
  const [isFormValid, setIsFormValid] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    const newFormData = { ...formData, [name]: value }
    setFormData(newFormData)

    // Simple validation
    setIsFormValid(newFormData.email.trim() !== "" && newFormData.password.trim() !== "")
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (isFormValid) {
      // In a real app, you would handle authentication here
      navigate("/account")
    }
  }

  return (
    <div className="login-container">
      <div className="login-header">
        <h1>Signin to your PopX account</h1>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit,</p>
      </div>

      <form className="login-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter email address"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Enter password"
            value={formData.password}
            onChange={handleChange}
          />
        </div>

        <button type="submit" onClick={() => navigate("/account")} className={`login-button ${isFormValid ? "active" : ""}`}>
          Login
        </button>
      </form>
    </div>
  )
}

export default Login

